import { configureStore } from '@reduxjs/toolkit';
import metaDataListReducer from '../slices/metaDataSlice';

export default configureStore({
  reducer: {
    metaDataList: metaDataListReducer
  }
});
